var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.5H21.5C22.8807 0.5 24 1.61929 24 3V15C24 16.3807 22.8807 17.5 21.5 17.5H2.5C1.11929 17.5 0 16.3807 0 15V3C0 1.61929 1.11929 0.5 2.5 0.5ZM2.5 2C1.94772 2 1.5 2.44772 1.5 3V5H22.5V3C22.5 2.44772 22.0523 2 21.5 2H2.5ZM22.5 8.5H1.5V15C1.5 15.5523 1.94772 16 2.5 16H21.5C22.0523 16 22.5 15.5523 22.5 15V8.5ZM4.5 12.25C4.5 11.8358 4.83579 11.5 5.25 11.5H9.75C10.1642 11.5 10.5 11.8358 10.5 12.25C10.5 12.6642 10.1642 13 9.75 13H5.25C4.83579 13 4.5 12.6642 4.5 12.25Z",
    fill: "#7E8CA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shopIcon.536eb0aef8541f5df2475aaa22840e8f.svg";
export { ForwardRef as ReactComponent };